export default __webpack_public_path__ + "static/media/NexusTek.7ee53b47.png";